module.exports = __webpack_public_path__ + "r-v3/img/highlighter_gray.9d1b847f.svg";